export const SEARCH_CERTIFICATES= 'SEARCH_ATTACHMENTS'
export const COMBINE_CERTIFICATES= 'COMBINE_ATTACHMENTS'